/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_Load_FailedInputs */



/**
* | output |
* | --- |
* | "Couldn't load cards." |
*
* @param {Palette_Load_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const palette_load_failed = /** @type {((inputs?: Palette_Load_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_Load_FailedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Karten konnten nicht geladen werden.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger les cartes.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("无法加载卡牌。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("無法載入卡牌。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카드를 불러오지 못했습니다.")
	return /** @type {LocalizedString} */ ("Couldn't load cards.")
});